/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const layoutSlice = createSlice({
  name: 'layout',
  initialState: {
    urlDomain: '',
    isWhiteLabelUrl: true,
  },
  reducers: {
    setUrlDomain: (state, action) => {
      const currentApiUrl = new URL(process.env.GATSBY_API_URL);
      const currentApiUrlParts = currentApiUrl.hostname.split('.');
      const currentApiUrlPartsLength = currentApiUrlParts.length;
      const currentDomain = action.payload;

      state.urlDomain = currentDomain;
      if (currentDomain.includes(`${currentApiUrlParts[currentApiUrlPartsLength - 2]}.${currentApiUrlParts[currentApiUrlPartsLength - 1]}`)) {
        state.isWhiteLabelUrl = false;
      } else {
        state.isWhiteLabelUrl = true;
      }
    },
  },
});

export const { setUrlDomain } = layoutSlice.actions;

export default layoutSlice.reducer;
